import { Theme, UiLegacy } from "@silvertours/front-legacy-shared";
import { analytics } from "@silvertours/front-entities";
import { addDays } from "date-fns/addDays";
import { formatISO } from "date-fns/formatISO";
import { isBefore } from "date-fns/isBefore";
import { parseISO } from "date-fns/parseISO";
import { startOfDay } from "date-fns/startOfDay";
import { useCallback, useState } from "react";
var SUPPORTED_LANGUAGES = [
    "de",
    "fr"
];
var STORAGE_NAME = "appPromotionBannerShownOn";
var PARAMETER_NAME = "disableAppPromotionBanner";
export var useShowAppBanner = function(language) {
    var ref = UiLegacy.useForegroundLayer(), isShowing = ref.isShowing, toggle = ref.toggle;
    var consent = analytics.useConsent();
    var ref1 = useState(false), isAlreadyShown = ref1[0], setIsAlreadyShown = ref1[1];
    var isLanguageAllowed = SUPPORTED_LANGUAGES.includes(language);
    var isMobileTouchDevice = Theme.useIsMobileTouchDevice();
    var preConditionsMet = isLanguageAllowed && isMobileTouchDevice;
    if (preConditionsMet) {
        var appPromotionBannerShownOn = null;
        if (consent === analytics.CookieConsent.Enabled) {
            appPromotionBannerShownOn = window.localStorage.getItem(STORAGE_NAME);
        }
        var startOfNextDay = appPromotionBannerShownOn ? addDays(startOfDay(parseISO(appPromotionBannerShownOn)), 1) : startOfDay(new Date());
        var shouldShowBanner = isBefore(startOfNextDay, Date.now());
        var shouldHideBanner = Boolean(new URLSearchParams(window.location.search).get(PARAMETER_NAME));
        if ((// cookie consent granted and last seen was yesterday
        consent === analytics.CookieConsent.Enabled && shouldShowBanner || // OR cookie consent denied and banner was not already rendered
        consent === analytics.CookieConsent.Disabled && !isAlreadyShown) && !shouldHideBanner && !isShowing) {
            toggle();
            setIsAlreadyShown(true);
        }
    }
    var onClose = useCallback(function() {
        toggle();
        setIsAlreadyShown(true);
        if (consent === analytics.CookieConsent.Enabled) {
            window.localStorage.setItem(STORAGE_NAME, formatISO(Date.now()));
        }
    }, [
        consent,
        toggle
    ]);
    return {
        isShowing: isShowing,
        onClose: onClose
    };
};
